import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Pagina404Component } from './paginas/pagina-404/pagina-404.component';
import { PaginaPrincipalComponent } from './paginas/pagina-principal/pagina-principal.component';
import { CalendarioGeneralComponent } from './paginas/calendario-general/calendario-general.component';
import { TareasDiaComponent } from './paginas/tareas-dia/tareas-dia.component';
import { BienvenidaComponent } from './componentes/bienvenida/bienvenida.component';
import { Evedisa22Component } from './paginas/evedisa-22/evedisa-22.component';
import { EvedisaMipresComponent } from './paginas/evedisa-mipres/evedisa-mipres.component';

import { AdhocRoutingModule } from './adhoc-routing.module';
import { AutorizacionModule } from '../nucleo/autorizacion/autorizacion.module';
import { FichaModule } from '../compartido/ficha/ficha.module';
import { FormularioModule } from '../compartido/formulario/formulario.module';
import { CalendarioComponent } from '../compartido/calendario/calendario.component';

import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';
import { MatStepperModule } from '@angular/material/stepper';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TablaModule } from '../compartido/tabla/tabla.module';
import { OrdenesModule } from '../ordenes/ordenes.module';

@NgModule({
  declarations: [
    Pagina404Component,
    PaginaPrincipalComponent,
    CalendarioGeneralComponent,
    TareasDiaComponent,
    BienvenidaComponent,
    Evedisa22Component,
    EvedisaMipresComponent,
  ],
  imports: [
    CommonModule,
    AdhocRoutingModule,
    AutorizacionModule,
    FichaModule,
    FormularioModule,
    CalendarioComponent,
    OrdenesModule,

    MatToolbarModule,
    MatSidenavModule,
    MatIconModule,
    MatButtonModule,
    MatListModule,
    MatMenuModule,
    MatBadgeModule,
    MatStepperModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    MatTooltipModule,
    TablaModule,
  ],
})
export class AdhocModule {}
